import { cn } from '../../lib/utils';

export type InputSize = 'sm' | 'md' | 'lg';

const sizeStyles: Record<InputSize, string> = {
  sm: 'h-8 rounded-lg px-2.5 text-xs',
  md: 'h-10 rounded-xl px-3 py-2 text-sm',
  lg: 'h-11 rounded-xl px-3.5 py-2 text-base',
};

export type InputStyleProps = {
  inputSize?: InputSize;
  /** Visually indicate validation errors */
  invalid?: boolean;
  fullWidth?: boolean;
  className?: string;
};

export function inputVariants({
  inputSize = 'md',
  invalid = false,
  fullWidth = true,
  className,
}: InputStyleProps = {}) {
  return cn(
    'min-w-0 border bg-background text-foreground outline-none transition placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50',
    fullWidth && 'w-full',
    invalid
      ? 'border-destructive focus-visible:ring-2 focus-visible:ring-destructive'
      : 'border-border focus-visible:ring-2 focus-visible:ring-primary-600',
    sizeStyles[inputSize],
    className,
  );
}
